var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key2 of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key2) && key2 !== except)
        __defProp(to, key2, { get: () => from[key2], enumerable: !(desc = __getOwnPropDesc(from, key2)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// lib/main.jsx
var main_exports = {};
__export(main_exports, {
  default: () => main_default
});
module.exports = __toCommonJS(main_exports);
var import_react = __toESM(require("react"));
function SourceFlowImage({ src, size, alt, resize = true, ...props }) {
  let variantUrl;
  if (!size && resize || !alt) {
    return /* @__PURE__ */ import_react.default.createElement("span", null, "Image must have a size and alt");
  }
  if (resize && src.includes("cdn.sourceflow.co.uk")) {
    key = src.split("cdn.sourceflow.co.uk").pop();
    variantUrl = `https://cdn.sourceflow.co.uk/variant/${size}${key}`;
  } else {
    variantUrl = src;
  }
  return /* @__PURE__ */ import_react.default.createElement("img", {
    src: variantUrl,
    alt,
    loading: "lazy",
    ...props
  });
}
var main_default = SourceFlowImage;
